import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

//currently this feature is not using anywhere in the frontend, check with backend team about the usage of this feature and the endpoints to be used for this feature.

// 1) CREATE GROUP CHAT
export const createGroupChat = createAsyncThunk("createGroupChat", async (groupData) => {
    try {
        const response = await axiosInstance.post("/messages/group-chat/create/", groupData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error:", error.response.data);
        throw error;
    }
});

// 2) UPDATE GROUP CHAT ROOM
export const updateGroupChat = createAsyncThunk("updateGroupChat", async ({ groupId, updateData }) => {
    try {
        const response = await axiosInstance.patch(`/messages/group-chat/${groupId}/update/`, updateData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

// 3) GROUP CHAT LIST
export const groupChatList = createAsyncThunk("groupChatList", async () => {
    try {
        const response = await axiosInstance.get("/messages/group-chat/list/");
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

// 4) GET ALL MESSAGES IN GROUP CHAT
export const getAllGroupMessages = createAsyncThunk("getAllGroupMessages", async (groupId) => {
    try {
        const response = await axiosInstance.get(`/messages/group-chat/${groupId}/messages/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

// 5) SEND GROUP MESSAGES
export const sendGroupMessage = createAsyncThunk("sendGroupMessage", async ({ groupId, messageData }) => {
    try {
        const response = await axiosInstance.post(`/messages/group-chat/${groupId}/send/`, messageData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

// 6) ADD MEMBERS
export const addGroupMembers = createAsyncThunk("addGroupMembers", async ({ groupId, user_ids }) => {
    try {
        const response = await axiosInstance.post(`/messages/group-chat/${groupId}/add-members/`, { user_ids });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

// 7) GROUP MEMBER LIST
export const groupMemberList = createAsyncThunk("groupMemberList", async (groupId) => {
    try {
        const response = await axiosInstance.get(`/messages/group-chat/${groupId}/members/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

// 8) DELETE GROUP CHAT
export const deleteGroupChat = createAsyncThunk("deleteGroupChat", async (groupId) => {
    try {
        const response = await axiosInstance.post(`/messages/group-chat/${groupId}/delete/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

// 9) LEAVE GROUP CHAT
export const leaveGroupChat = createAsyncThunk("leaveGroupChat", async (groupId) => {
    try {
        const response = await axiosInstance.post(`/messages/group-chat/${groupId}/leave/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

// 10) FRIENDS LIST FOR GROUP CHAT
export const groupChatFriends = createAsyncThunk("groupChatFriends", async () => {
    try {
        const response = await axiosInstance.get(`/messages/friends/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

// 11) REACTION ON GROUP MESSAGE
export const groupMessageReaction = createAsyncThunk("groupMessageReaction", async (messageId) => {
    try {
        const response = await axiosInstance.post(`/messages/group-chat/${messageId}/reaction/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

// 12) GROUP DETAILS BY GROUP ID
export const groupDetailsById = createAsyncThunk("groupDetailsById", async (groupId) => {
    try {
        const response = await axiosInstance.get(`/messages/group-chat/${groupId}/detail/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

// 13) MUTE / UNMUTE GROUP CHAT
export const muteUnmuteGroupChat = createAsyncThunk("muteUnmuteGroupChat", async (groupId) => {
    try {
        const response = await axiosInstance.post(`/messages/group-chat/${groupId}/toggle-mute/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

// 14) TOTAL UNREAD GROUP MESSAGES
export const totalUnreadGroupMessages = createAsyncThunk("totalUnreadGroupMessages", async () => {
    try {
        const response = await axiosInstance.get(`/messages/group-chat/unread-count/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

// 15) MARK ALL MESSAGES AS READ IN GROUP CHAT
export const markAllMessagesAsRead = createAsyncThunk("markAllMessagesAsRead", async (groupId) => {
    try {
        const response = await axiosInstance.post(`/messages/group-chat/${groupId}/mark-read/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

export const MessageGroupSlice = createSlice({
    name: "messageGroup",
    initialState: {
        groupChatListData: [],
        groupChatFriendsList: [],
        groupMemberList: [],
        groupMessages: [],
        createdGroup: null,
        updatedGroup: null,
        totalGroupUnreadCount: null,
        sendGroupMessageResult: null,
        addGroupMembersResult: null,
        deleteGroupResult: null,
        leaveGroupResult: null,
        groupMessageReactionResult: null,
        groupMessageReactionLoading: false,
        loading: false,
        error: null,
        sendGroupMessageLoading: false,
        addGroupMembersLoading: false,
        deleteGroupLoading: false,
        leaveGroupLoading: false,
        updateGroupLoading: false,
        createGroupLoading: false,
        groupDetailsByIdResult: null,
        groupDetailsByIdLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        // 1) CREATE GROUP CHAT
        builder.addCase(createGroupChat.pending, (state) => {
            state.createGroupLoading = true;
            state.error = null;
        });
        builder.addCase(createGroupChat.fulfilled, (state, action) => {
            state.createGroupLoading = false;
            state.createdGroup = action.payload;
            state.error = null;
        });
        builder.addCase(createGroupChat.rejected, (state, action) => {
            state.createGroupLoading = false;
            state.error = action.error.message;
        });

        // 2) UPDATE GROUP CHAT ROOM
        builder.addCase(updateGroupChat.pending, (state) => {
            state.updateGroupLoading = true;
            state.error = null;
        });
        builder.addCase(updateGroupChat.fulfilled, (state, action) => {
            state.updateGroupLoading = false;
            state.updatedGroup = action.payload;
            state.error = null;
        });
        builder.addCase(updateGroupChat.rejected, (state, action) => {
            state.updateGroupLoading = false;
            state.error = action.error.message;
        });

        // 3) GROUP CHAT LIST
        builder.addCase(groupChatList.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(groupChatList.fulfilled, (state, action) => {
            state.loading = false;
            state.groupChatListData = action.payload;
            state.error = null;
        });
        builder.addCase(groupChatList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        // 4) GET ALL MESSAGES IN GROUP CHAT
        builder.addCase(getAllGroupMessages.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getAllGroupMessages.fulfilled, (state, action) => {
            state.loading = false;
            state.groupMessages = action.payload;
            state.error = null;
        });
        builder.addCase(getAllGroupMessages.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        // 5) SEND GROUP MESSAGES
        builder.addCase(sendGroupMessage.pending, (state) => {
            state.sendGroupMessageLoading = true;
            state.error = null;
        });
        builder.addCase(sendGroupMessage.fulfilled, (state, action) => {
            state.sendGroupMessageLoading = false;
            state.sendGroupMessageResult = action.payload;
            state.error = null;
        });
        builder.addCase(sendGroupMessage.rejected, (state, action) => {
            state.sendGroupMessageLoading = false;
            state.error = action.error.message;
        });

        // 6) ADD MEMBERS
        builder.addCase(addGroupMembers.pending, (state) => {
            state.addGroupMembersLoading = true;
            state.error = null;
        });
        builder.addCase(addGroupMembers.fulfilled, (state, action) => {
            state.addGroupMembersLoading = false;
            state.addGroupMembersResult = action.payload;
            state.error = null;
        });
        builder.addCase(addGroupMembers.rejected, (state, action) => {
            state.addGroupMembersLoading = false;
            state.error = action.error.message;
        });

        // 7) GROUP MEMBER LIST
        builder.addCase(groupMemberList.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(groupMemberList.fulfilled, (state, action) => {
            state.loading = false;
            state.groupMemberList = action.payload;
            state.error = null;
        });
        builder.addCase(groupMemberList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        // 8) DELETE GROUP CHAT
        builder.addCase(deleteGroupChat.pending, (state) => {
            state.deleteGroupLoading = true;
            state.error = null;
        });
        builder.addCase(deleteGroupChat.fulfilled, (state, action) => {
            state.deleteGroupLoading = false;
            state.deleteGroupResult = action.payload;
            state.error = null;
        });
        builder.addCase(deleteGroupChat.rejected, (state, action) => {
            state.deleteGroupLoading = false;
            state.error = action.error.message;
        });

        // 9) LEAVE GROUP CHAT
        builder.addCase(leaveGroupChat.pending, (state) => {
            state.leaveGroupLoading = true;
            state.error = null;
        });
        builder.addCase(leaveGroupChat.fulfilled, (state, action) => {
            state.leaveGroupLoading = false;
            state.leaveGroupResult = action.payload;
            state.error = null;
        });
        builder.addCase(leaveGroupChat.rejected, (state, action) => {
            state.leaveGroupLoading = false;
            state.error = action.error.message;
        });

        // 10) FRIENDS LIST FOR GROUP CHAT
        builder.addCase(groupChatFriends.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(groupChatFriends.fulfilled, (state, action) => {
            state.loading = false;
            state.groupChatFriendsList = action.payload;
            state.error = null;
        });
        builder.addCase(groupChatFriends.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        // 11) REACTION ON GROUP MESSAGE
        builder.addCase(groupMessageReaction.pending, (state) => {
            state.groupMessageReactionLoading = true;
            state.error = null;
        });
        builder.addCase(groupMessageReaction.fulfilled, (state, action) => {
            state.groupMessageReactionLoading = false;
            state.groupMessageReactionResult = action.payload;
            state.error = null;
        });
        builder.addCase(groupMessageReaction.rejected, (state, action) => {
            state.groupMessageReactionLoading = false;
            state.error = action.error.message;
        });

        // 12) GROUP DETAILS BY GROUP ID
        builder.addCase(groupDetailsById.pending, (state) => {
            state.groupDetailsByIdLoading = true;
            state.error = null;
        });
        builder.addCase(groupDetailsById.fulfilled, (state, action) => {
            state.groupDetailsByIdLoading = false;
            state.groupDetailsByIdResult = action.payload;
            state.error = null;
        });
        builder.addCase(groupDetailsById.rejected, (state, action) => {
            state.groupDetailsByIdLoading = false;
            state.error = action.error.message;
        });

        // 13) MUTE / UNMUTE GROUP CHAT
        builder.addCase(muteUnmuteGroupChat.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(muteUnmuteGroupChat.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
        });
        builder.addCase(muteUnmuteGroupChat.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        // 14) TOTAL UNREAD GROUP MESSAGES
        builder.addCase(totalUnreadGroupMessages.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(totalUnreadGroupMessages.fulfilled, (state, action) => {
            state.loading = false;
            state.totalGroupUnreadCount = action.payload;
            state.error = null;
        });
        builder.addCase(totalUnreadGroupMessages.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        // 15) MARK ALL MESSAGES AS READ IN GROUP CHAT
        builder.addCase(markAllMessagesAsRead.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(markAllMessagesAsRead.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
        });
        builder.addCase(markAllMessagesAsRead.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});

export default MessageGroupSlice.reducer;